<template>
    <div class="tw-w-full tw-bg-bgMain tw-py-10 tw-px-4 md:tw-py-24 md:tw-px-0 ">

        <div class="tab-view-container tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center "
            :class="{ 'animate-slide-up': isVisible }">

            <span class="tw-text-textMain tw-text-xl md:tw-text-4xl tw-font-bold tw-mb-4 ">{{ $t('我们能做什么')
                }}</span>
            <span class="tw-w-full tw-text-center tw-text-xs md:tw-text-sm  tw-text-textDisabled  tw-mb-5 md:tw-mb-10 ">{{ $t('我们能做什么介绍')
                }}</span>

            <div class="tw-flex ">
                <div class="tw-flex tw-flex-col tw-justify-center tw-items-center">
                    <span class="height-light-text tw-text-2xl md:tw-text-4xl tw-font-bold ">
                        {{ animatedYears }}{{ $t('年+') }}
                    </span>
                    <span class="tw-text-textDisabled tw-mt-1">{{ $t('安全服务') }}</span>
                </div>
                <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-ml-20">
                    <span class="height-light-text tw-text-2xl md:tw-text-4xl tw-font-bold ">
                        {{ formatNumber(animatedProjects) }}+
                    </span>
                    <span class="tw-text-textDisabled tw-mt-1">{{ $t('成功项目') }}</span>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import { solutionsApi } from "@/api/modules/home";
export default {
    name: 'WeCanDo',
    data() {
        return {
            tabsList: [],
            isLoading: true,
            isVisible: false,
            observer: null,
            // 动画相关数据
            animatedYears: 0,
            animatedProjects: 0,
            targetYears: 10,
            targetProjects: 1000,
            animationStarted: false
        };
    },
    mounted() {
        const info = JSON.parse(localStorage.getItem('indexInfo'));
        if (info) {
            this.getList();
        }
        this.$nextTick(() => {
            setTimeout(() => {
                this.initIntersectionObserver();
            }, 500);
        });
    },
    methods: {
        initIntersectionObserver() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.isVisible) {
                        this.isVisible = true;
                        // 启动数字动画
                        this.startNumberAnimation();
                        // 动画只执行一次，所以可以断开观察器
                        this.observer.disconnect();
                    }
                });
            }, {
                threshold: 0.1, // 当组件10%可见时触发
            });

            this.observer.observe(this.$el);
        },
        
        startNumberAnimation() {
            if (this.animationStarted) return;
            this.animationStarted = true;
            
            // 年份动画 (0 -> 10)
            this.animateNumber(
                0, 
                this.targetYears, 
                1500, // 1.2秒
                (value) => {
                    this.animatedYears = Math.floor(value);
                }
            );
            
            // 项目数量动画 (0 -> 1000)，延迟200ms开始
            setTimeout(() => {
                this.animateNumber(
                    0, 
                    this.targetProjects, 
                    1800, // 1.5秒
                    (value) => {
                        this.animatedProjects = Math.floor(value);
                    }
                );
            }, 200);
        },
        
        animateNumber(start, end, duration, callback) {
            const startTime = performance.now();
            const change = end - start;
            
            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // 使用 easeOutQuart 缓动函数
                const easeProgress = 1 - Math.pow(1 - progress, 4);
                const currentValue = start + change * easeProgress;
                
                callback(currentValue);
                
                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            };
            
            requestAnimationFrame(animate);
        },
        
        formatNumber(num) {
            // 格式化数字，添加千位分隔符
            return Math.floor(num).toLocaleString();
        },

        getList() {
            solutionsApi({
                pageIndex: 1,
                pageSize: 5,
            }).then((res) => {
                this.tabsList = res.data.list || [];
            })
        },
        handleClickRoute(row) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            if (row.id) {
                localStorage.setItem("detailForm", JSON.stringify(row))
                this.$router.push({
                    path: '/solution/' + row.id + "?isApi=false"
                });
            } else {
                this.$router.push({
                    path: '/solution'
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.tab-view-container {
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
    opacity: 1;
    transform: translateY(0);
}

.height-light-text {
    // 添加数字变化时的平滑过渡
    transition: all 0.1s ease-out;
}
</style>